export default "__VITE_ASSET__CfXDngUF__"